import React, { Component } from "react";
import { connect } from "react-redux";

import { Form, Field } from "react-final-form";
import Button from "@components/Button";
import Textarea from "@components/Form/Textarea";

import {
  composeFormValidators,
  isRequired,
  hasMaxLength,
  hasMinLength,
} from "@lib/validations";

import Loading from "@components/Loading";
import Alert from "@components/Alert";

import { apiCall } from "@store/app/actions";
import { postReviewsApi, postQuestionsApi } from "@lib/api/index";

class AddCommentForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSent: false,
    };
  }

  sendForm = async (values) => {
    const { user, type, productId, parentId } = this.props;
    const customerName = user.isLoggedIn
      ? `${user.customer.first_name} ${user.customer.last_name}`
      : "";

    const { body } = values;

    const payload = {
      customerName,
      productId,
      parentId,
      body,
    };

    const addResponse = await this.props.apiCall({
      spinner: true,
      alert: true,
      apiCall: type === "reviews" ? postReviewsApi : postQuestionsApi,
      apiArgs: [payload],
      returnResponse: true,
    });

    if (addResponse && addResponse.ok) {
      this.setState({
        isSent: true,
      });
    }
  };

  render() {
    const { isSent } = this.state;
    const {
      closeForm,
      type,
      user: { isLoggedIn, isInitial },
    } = this.props;

    if (isSent) {
      return (
        <div className="mt-4">
          <Alert type="success" onClose={closeForm}>
            {type === "reviews"
              ? "Comentariul tau a fost adaugat. Iti multumim pentru contributie."
              : "Raspunsul tau a fost adaugat. Iti multumim pentru contributie."}
          </Alert>
        </div>
      );
    }

    return (
      <>
        {isInitial && <Loading height={100} />}
        {!isLoggedIn && (
          <div className="mt-4">
            <Alert type="warning">Trebuie sa fii autentificat.</Alert>
          </div>
        )}
        {isLoggedIn && (
          <Form
            onSubmit={this.sendForm}
            render={({ handleSubmit }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <>
                    <div className="mt-4">
                      <div>
                        <label
                          htmlFor="body"
                          className="Form-label is-required inline-block"
                        >
                          <span>Adauga comentariul tau</span>
                        </label>
                        {type === "reviews" ? (
                          <span className="inline-block mb-1 ml-1 text-gray-light">
                            {" "}
                            (100 — 2000 de caractere)
                          </span>
                        ) : (
                          <span className="inline-block mb-1 ml-1 text-gray-light">
                            {" "}
                            (2 — 2000 de caractere)
                          </span>
                        )}
                      </div>
                      <Field
                        name="body"
                        id="review_body"
                        component={Textarea}
                        rows="5"
                        validate={composeFormValidators(
                          isRequired(),
                          hasMaxLength(2000),
                          hasMinLength(type === "reviews" ? 100 : 2)
                        )}
                      />
                    </div>

                    <div className="md:flex items-center mt-4">
                      <div className="hidden md:block">
                        <Button title="Trimite comentariul" type="submit" />
                      </div>

                      <div className="md:hidden">
                        <Button
                          title="Trimite comentariul"
                          type="submit"
                          size="normal"
                          display="block"
                        />
                      </div>

                      <div className="md:ml-4 text-center mt-4 md:mt-0">
                        <button
                          className="text-red-brand font-bold focus:outline-none focus:underline hover:underline"
                          type="button"
                          onClick={closeForm}
                        >
                          Renunta
                        </button>
                      </div>
                    </div>
                  </>
                </form>
              );
            }}
          />
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({
    user: state.user,
  }),
  {
    apiCall,
  }
)(AddCommentForm);
